import { createSlice } from '@reduxjs/toolkit'

export const pagesSlice = createSlice({
    name: 'pages',
    initialState: {
        customPages: [],
        isLoading: false,
        error: null,
    },
    reducers: {
        updatePagesData: (state, action) => {
            state.customPages = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setPagesLoading: (state) => {
            state.isLoading = true;
        },
        setPagesError: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
    },
})

export const { updatePagesData, setPagesLoading, setPagesError } = pagesSlice.actions

export default pagesSlice.reducer
